<template>
	<div>
		<botao-voltar label-voltar="Voltar para listagem" :nome-rota-anterior="rotaListagem"></botao-voltar>
		<az-container>
			<v-card elevation="0">
				<v-card-text>
					<formulario-revisao :funcao-salvar-revisao="criarRevisao"></formulario-revisao>
				</v-card-text>
			</v-card>
		</az-container>
	</div>
</template>

<script>
import { actionTypes, routesNames } from '@/core/constants'
import FormularioRevisao from '@/views/pages/configuracao/revisoes/formulario-revisao/FormularioRevisao.vue'
import BotaoVoltar from '@/views/components/BotaoVoltar.vue'

export default {
	name: 'revisao-criacao',
	components: { BotaoVoltar, FormularioRevisao },
	data() {
		return {
			rotaListagem: routesNames.CONFIGURACAO.REVISOES.REVISOES_VIEW,
		}
	},
	methods: {
		async criarRevisao(payload) {
			const response = await this.$store.dispatch(actionTypes.CONFIGURACAO.REVISOES.INSERIR_REVISAO, payload)
			this.mostrarNotificacaoSucessoDefault()
			await this.$router.push({
				name: routesNames.CONFIGURACAO.REVISOES.REVISOES_EDICAO_VIEW,
				params: { id: response.id },
			})
		},
	},
}
</script>
